<safety-message-info [ride]="ride"></safety-message-info>
<div id="rideMap">
  <button (click)="reload()" *ngIf="ride?.status == 'PICKED_UP'">
    <img src="/assets/images/btn_account_refresh@4x.png" id="refreshed">
    <img src="/assets/images/btn_account_refresh_loading@4x.png" id="refreshing">
    새로고침
  </button>
</div>
<safety-message-download></safety-message-download>
